// 封装WebSocket服务
class SocketService {
  constructor() {
    this.ws = null;
    this.isConnected = false;
    this.url = 'wss://shiguangtongpin.cn/ws';
    this.reconnectTimer = null;
    this.eventListeners = new Map(); // 存储事件监听器
    this.connecting = false; // 新增：避免重复连接
    this.reconnectAttempts = 0; // 新增：记录重连次数
    this.maxReconnectAttempts = 10; // 新增：最大重连次数
  }

  // 连接WebSocket，支持传入参数
  connect() {
    // 如果正在连接中或已连接，则返回
    if (this.connecting || this.isConnected) return;

    this.connecting = true;
    
    // 构建带参数的URL


    try {
      this.ws = new WebSocket(this.url);

      this.ws.onopen = () => {
        console.log('WebSocket连接成功');
        this.isConnected = true;
        this.connecting = false;
        this.reconnectAttempts = 0; // 重置重连次数
        this.clearReconnectTimer();
        this.emit('open');
      };

      this.ws.onmessage = (event) => {
        try {
          const message = JSON.parse(event.data);
          this.emit('message', message);
        } catch (error) {
          console.error('解析WebSocket消息失败:', error);
          this.emit('error', error);
        }
      };

      this.ws.onclose = (event) => {
        console.log(`WebSocket断开连接: 代码=${event.code}, 原因=${event.reason}`);
        this.isConnected = false;
        this.connecting = false;
        this.emit('close', event);
        
        // 只有非正常关闭才重连
        if (event.code !== 1000 && event.code !== 1001) {
          this.startReconnect();
        }
      };

      this.ws.onerror = (error) => {
        console.error('WebSocket错误:', error);
        this.emit('error', error);
        // 错误发生时不直接设置isConnected为false，由onclose处理
      };
    } catch (error) {
      console.error('创建WebSocket连接失败:', error);
      this.connecting = false;
      this.emit('error', error);
      this.startReconnect();
    }
  }

  // 发送消息
  send(data) {
    return new Promise((resolve, reject) => {
      if (!this.isConnected || !this.ws) {
        reject(new Error('WebSocket未连接'));
        return;
      }

      try {
        const message = typeof data === 'string' ? data : JSON.stringify(data);
        this.ws.send(message);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  // 关闭连接
  close(code = 1000, reason = '正常关闭') {
    if (this.ws) {
      this.ws.close(code, reason);
      this.ws = null;
      this.isConnected = false;
      this.connecting = false;
      this.clearReconnectTimer();
    }
  }

  // 开始重连
  startReconnect() {
    if (this.reconnectTimer || this.connecting) return;
    
    // 如果达到最大重连次数，停止尝试
    if (this.reconnectAttempts >= this.maxReconnectAttempts) {
      console.error('已达到最大重连次数，停止尝试');
      this.emit('maxReconnect', this.maxReconnectAttempts);
      return;
    }

    // 指数退避重连策略
    const delay = Math.min(1000 * Math.pow(2, this.reconnectAttempts), 30000); // 最大延迟30秒
    this.reconnectAttempts++;
    
    console.log(`将在${delay/1000}秒后尝试重连（第${this.reconnectAttempts}次）`);
    this.reconnectTimer = setTimeout(() => {
      console.log('尝试重新连接WebSocket...');
      this.connect({ userId: this.userId }); // 使用上次的userId重连
    }, delay);
  }

  // 清除重连计时器
  clearReconnectTimer() {
    if (this.reconnectTimer) {
      clearTimeout(this.reconnectTimer); // 改为clearTimeout，因为使用setTimeout而非setInterval
      this.reconnectTimer = null;
    }
  }

  // 注册事件监听器
  on(event, callback) {
    if (!this.eventListeners.has(event)) {
      this.eventListeners.set(event, []);
    }
    this.eventListeners.get(event).push(callback);
  }

  // 移除事件监听器
  off(event, callback) {
    if (this.eventListeners.has(event)) {
      if (callback) {
        const listeners = this.eventListeners.get(event);
        const index = listeners.indexOf(callback);
        if (index !== -1) {
          listeners.splice(index, 1);
        }
      } else {
        this.eventListeners.set(event, []);
      }
    }
  }

  // 触发事件
  emit(event, data) {
    if (this.eventListeners.has(event)) {
      // 创建监听器数组的副本，避免在迭代中修改数组导致问题
      [...this.eventListeners.get(event)].forEach(callback => {
        try {
          callback(data);
        } catch (error) {
          console.error(`处理${event}事件时出错:`, error);
        }
      });
    }
  }
}

// 导出单例实例
export default new SocketService();
